import { gql } from '../../../apollo/__generated__';

export const ADMIN_EVENT_TRANSACTIONS = gql(`
  query AdminEventTransactions($eventId: ID!) {
    eventTransactions(eventId: $eventId) {
      id
      status
      type
      voucher {
        id
        code
        amount
      }
      payer {
        id
        firstname
        lastname
        email
      }
      helloAssoOrderId
      helloAssoCheckoutIntentId
      createdAt
      updatedAt
      user {
        id
        firstname
        lastname
        email
      }
    }
  }
`);
